import React from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './VideoSlide.scss'


const VideoSlide = ({ buttonCaption, video, closeVideo, isVisible }) => {
  return (
    <CSSTransitionGroup
      transitionName='ou_video'
      transitionEnterTimeout={1500}
      transitionLeaveTimeout={1500}
    >
      {isVisible && <div className='ou_scene ou_video ou_video_container' key='video' onClick={() => {
        if (video.isTappable) {
          return closeVideo()
        }
        return null
      }}>
        <video
          id='ou_video'
          className='ou_video__video'
          preload='none'
          loop
          muted
          autoPlay
          playsInline
          style={{ backgroundImage: `url(${video.thumbUrl})` }}
          src={video.url}
        />
        <div className='ou_video__button-wrap'>
          <button id='ou_video__button' className='ou_video__button' onClick={closeVideo}>{buttonCaption}</button>
        </div>
      </div>}
    </CSSTransitionGroup>
  )
}

VideoSlide.propTypes = {
  buttonCaption: PropTypes.string,
  video: PropTypes.object,
  closeVideo: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
}

export default VideoSlide



// WEBPACK FOOTER //
// ./src/templates/outSide/components/scenes/VideoSlide.js